import { combineReducers } from "redux";
import usersList from "./usersList";
import editUser from "./editUser";
import groups from "./groups";
import files from "./files";

export default combineReducers({
    usersList,
    editUser,
    groups,
    files
});
